// extracted by mini-css-extract-plugin
module.exports = {"container":"e_1q","anchor":"e_2q"};